export const REACT_FLOW_CARD_DEFAULT_BOX_SHADOW = `0px 1px 2px 0px rgba(16, 24, 40, .05)`;
export const REACT_FLOW_CARD_GROUPED_BOX_SHADOW = `0px 0px 3px 4px rgba(16, 24, 40, .1)`;
export const REACT_FLOW_CARD_HIGHLIGHTED_BOX_SHADOW = `0px 4px 6px -2px rgba(16, 24, 40, .03), 0px 12px 16px -4px rgba(16, 24, 40, .08)`;
export const REACT_FLOW_CARD_BORDER_RADIUS = 3;
